import React, {createContext, useState, useCallback, useEffect} from "react";
import { createPortal } from "react-dom";
import cn from 'classnames';
import styles from './ModaContext.module.sass';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import OutsideClickHandler from 'react-outside-click-handler';
import Icon from "../../components/Icon";
import { useRef } from "react";
import Image from "../../components/Image";

export const ModalContext = createContext(); 

const ModalContextProvider = ({children}) => {

    const [data, setData] = useState();
    const dataRef = useRef(); 
    dataRef.current = data;

    const show = function( { title, content, closeButton = true, closeOutside = true, onClose } ){

        setData({
            title: title || '',
            content: content || <></>,
            closeButton: closeButton,
            closeOutside: closeOutside,
            onClose: onClose
        });
        
    };

    const hide = function(){
        setData( undefined );
    };

    const close = function(){

        if( dataRef.current ) dataRef.current.onClose?.();
        hide();

    }

    const escFunction = useCallback(
        e => e.keyCode === 27 && hide(),
        [data]
    );

    useEffect(() => {
        document.addEventListener('keydown', escFunction, false);
        return () => {
            document.removeEventListener('keydown', escFunction, false);
        };
    }, [escFunction]);

    useEffect(() => {
        if (data) {
            const target = document.querySelector('#modal');
            disableBodyScroll(target);
        } else {
            clearAllBodyScrollLocks();
        }
    }, [data]);

    const setTitle = useCallback( (newTitle) => {
        setData({
            ...dataRef.current,
            title: newTitle || '',
        });
    }, [data]);

    return (
        <ModalContext.Provider value={ {hide, show, setTitle} }>
            {children}
            { data && <div className={styles.modal} id='modal'>
                <div className={styles.outer}>
                    <OutsideClickHandler onOutsideClick={(data.closeOutside && close) || (() => {})}>
                        <div className={styles.modal_header}>
                            <h4 className={styles.title}>{data.title}</h4>
                            {data.closeButton && 
                            <button className={styles.close} onClick={close}>
                                <Image src={'/assets/icon_close.png'} srcDark={'/assets/icon_close.png'}/>
                                {/* <Icon name='close' size='14' className={'icon'}/> */}
                            </button>
                            }
                        </div>
                        <div className={ styles.modal_content } >
                            {data.content}
                        </div>
                    </OutsideClickHandler>
                </div>
            </div> }
        </ModalContext.Provider>
    );

};

export default ModalContextProvider;